import styled from 'styled-components';
import { crTheme, Button, Text } from '@comicrelief/component-library';

const ColouredBackground = styled.div`
  border: none;
  border-radius: 1.25rem;
  background: ${crTheme.color('coral_light')};
  padding: 60px 35px;
  text-align: center;
`;

const StyledHeading = styled(Text)`
  margin-top: 20px;
  text-transform: uppercase;
`;

const StyledSubHeading = styled(Text)`
  margin-top: 35px;
`;

const StyledText = styled(Text)`
  margin-top: 25px;
`;

const StyledTransaction = styled(Text)`
  margin-top: 2rem;
  margin-bottom: 0;
  text-align: center;
`;

const Box = styled.div`
  margin-top: 2rem;
  border: 1px solid ${crTheme.color('grey')};
  padding: 24px 26px 30px 26px;
  border-radius: 0.5rem;
  text-align: center;
  background-color: ${crTheme.color('white')};
  @media ${crTheme.allBreakpoints('M')} {
    background-color: ${crTheme.color('grey_light')};
  }
`;

const StyledButton = styled(Button)`
  margin-top: 15px;
`;

const StyledButtonWrapper = styled.div`
  margin-top: 40px;
  a {
    width: 100%;
  }
`;

const SocialsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  margin-top: 1rem;
  p {
    margin: 0;
  }
`;

const FacebookIcon = styled.img`
  --size: 35px;
  width: var(--size);
  height: var(--size);
`;

const XIconWrapper = styled.div`
  --size: 35px;
  width: var(--size);
  height: var(--size);
  background: black;
  border-radius: 50%;
  padding: calc(var(--size) * 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const XIcon = styled.img`
  width: calc(var(--size) * 0.6);
  height: calc(var(--size) * 0.6);
`;

const ThankYouCopyWrapper = styled.div`

  a {
    border: 3px solid ${crTheme.color('black')};
    color: ${crTheme.color('black')};
    background: transparent;
    width: 100%;

    &:hover,
    &:focus {
      border: 3px solid ${crTheme.color('red')};
      color: ${crTheme.color('white')};
      background: ${crTheme.color('red')};
    }
  }
`;

export {
  StyledHeading,
  StyledSubHeading,
  StyledText,
  StyledTransaction,
  StyledButton,
  StyledButtonWrapper,
  ColouredBackground,
  Box,
  SocialsWrapper,
  FacebookIcon,
  XIcon,
  XIconWrapper,
  ThankYouCopyWrapper
};
